import { Button, styled, Typography } from "@mui/material";

export const StyledNovedades = {
  CustomToolbar: styled("div")(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    backgroundColor: theme.palette.background.default,
    padding: theme.spacing(1, 2),
    borderTop: `1px solid ${theme.palette.divider}`,
  })),

  SelectedMessage: styled(Typography)(({ theme }) => ({
    fontWeight: 500,
    color: theme.palette.text.primary,
  })),

  ToolbarButton: styled(Button)(({ theme }) => ({
    marginLeft: theme.spacing(2),
  })),
  Container: styled("div")(({ theme }) => ({
    width: "100%",
  })),
};
